import { agencyObj } from '../store'
export { agencyObj } from '../store'

// These are the ids for the netnatives controlled agencies, this has to
// include all ids from different envs.
const nativesIDS = ['52035c0b01bb5a9b5d130923']
const xEqualsIDS = ['634eae1d7af11a1129ff8231']

/**
 * @return {Boolean}
 * @description Checks if the agency is the net natives agency or another
 * agency that is net natives controlled...
 */
export function isNative(agency) {
  const session = agencyObj(agency)
  const res = nativesIDS.indexOf(session._id) !== -1
  return res
}

/**
 * @param {Object|Undefined} agency - optional agency object
 * @returns {Boolean}
 * @description Checks if the agency is the xequals agency
 */
export function isXEquals(agency) {
  const session = agencyObj(agency)
  return xEqualsIDS.indexOf(session._id) !== -1
}

/**
 * Displays a message to the user to inform them that the agency has access
 * to all the client data on accounts
 * @return {Boolean}
 */
export function hasOverride(agency) {
  const session = agencyObj(agency)
  return session.dangerouslySkipTempDataAccess
}

/**
 *  Returns boolean for non premium nav view
 */
export function checkAODataLabs(agency) {
  const session = agencyObj(agency)
  const hasAODataLabs = session.bespokeDashboards.find((dashboard) => {
    return (
      dashboard.location === 'datalabs' &&
      dashboard.url.length > 0 &&
      dashboard.agencyOnly
    )
  })

  if (hasAODataLabs === undefined) return false
  return true
}
